import { render, staticRenderFns } from "./UsersSearchResult.vue?vue&type=template&id=620e13f3&scoped=true"
import script from "./UsersSearchResult.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersSearchResult.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UsersSearchResult.vue?vue&type=style&index=0&id=620e13f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e13f3",
  null
  
)

export default component.exports